
import Vue from "vue";

import ShowSpinners from "@/common/components/ShowSpinners.vue";
import { DatePickerEnum } from "@/features/model/enums/DatePickerEnum";
import { FormMcaOnlineReportTypeEnum } from "@/features/model/enums/FormMcaOnlineReportTypeEnum";
import CustomDatePicker from "@/components/CustomDatePicker.vue";
import McaPreviewOnlineReportPDF from "@/features/model/components/mca/McaPreviewOnlineReport/McaPreviewOnlineReportPDF.vue";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export default Vue.extend({
  name: "McaPreviewCustomReport",
  components: { ShowSpinners, CustomDatePicker, McaPreviewOnlineReportPDF },
  data() {
    return {
      customizeStartDate: null,
      customizeEndDate: null,
      isShowPreviewOnlineReport: false,
      formMcaOnlineReportTypeEnum: FormMcaOnlineReportTypeEnum,
      datePickerEnum: DatePickerEnum,
      isStartDateError: false,
      isEndDateError: false,
      pdfUrl: "",
      isLoading: false,
    };
  },
  computed: {
    isSubmitDisabled() {
      return !this.customizeStartDate || !this.customizeEndDate;
    },
    companyId() {
      return this.$store.state.company.id;
    },
    modelId() {
      return this.$store.state.model.id;
    },
  },
  methods: {
    async submitToPreviewReport() {
      this.isLoading = true;

      if (!this.customizeStartDate) {
        this.isStartDateError = true;
        return;
      }

      if (!this.customizeEndDate) {
        this.isEndDateError = true;
        return;
      }

      const dateStart = dayjs.utc(this.customizeStartDate);

      const dateEnd = dayjs.utc(this.customizeEndDate);
      const fullDateEnd = dateEnd.set("hour", 23).set("minute", 59).set("second", 59).set("millisecond", 999);

      if (dateStart > dateEnd) {
        this.$swal({
          icon: "warning",
          title: "Warning",
          text: "The end date must be after the start date.",
        });
        this.isLoading = false;
        return;
      }

      // Note: for sending to back-end ISO date format
      const dateStartISO = dateStart.toISOString();

      const dateEndISO = fullDateEnd.toISOString();

      try {
        const companyId = this.companyId;
        const modelId = this.modelId;

        const equipmentModelTypeCode = "MCA";

        const response = await (this as any).$dep.modelUseCase.getOnlineReportPDF(
          companyId,
          modelId,
          dateStartISO,
          dateEndISO,
          equipmentModelTypeCode
        );

        if (response && !response.url) {
          throw new Error(response.detail);
        }

        this.pdfUrl = response.url;
        this.isShowPreviewOnlineReport = true;
      } catch (err) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "An error occurred while loading the report. Please try again.",
          showConfirmButton: false,
          timer: 1500,
        });
        console.error(err);
        console.error("submitToPreviewReport error");
      } finally {
        this.isLoading = false;
      }
    },
    limitMaxDate(date: string, noOfDate: number, isLimitUntilCurrentDay = false) {
      const initial = new Date(date);

      // Note: Add max noOfDate days can select
      initial.setDate(initial.getDate() + noOfDate);

      // Note: Current date
      const currentDate = new Date();

      // Note: Set limit can select until current day
      if (isLimitUntilCurrentDay && initial > currentDate) {
        return currentDate.toISOString().substr(0, 10);
      }

      // Note: Format as 'yyyy-MM-dd'
      return initial.toISOString().substr(0, 10);
    },
    handleOnReset() {
      // Note: Reset to default value
      this.isShowPreviewOnlineReport = false;
      this.pdfUrl = "";
      this.customizeStartDate = null;
      this.customizeEndDate = null;
    },
  },
  watch: {
    currentReportType(newValue) {
      if (newValue.name === this.formMcaOnlineReportTypeEnum.MONTHLY) {
        this.customizeStartDate = null;
        this.customizeEndDate = null;
      }
    },
  },
});
